<div class="container" data-meta="brand-master-container" aria-hidden="false">
  <mat-card appearance="outlined" data-section="brand-master" data-random="x1y2z">
    <mat-card-title data-element="brand-title">Brand Master</mat-card-title>

    <!-- Add Button -->
    <button
      style="position: absolute; top: 8px; right: 10px; height: 35px; width: 35px;"
      [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'"
      color="accent"
      tabindex="0"
      matTooltip="Add Brand"
      (click)="onAddBrandClick()"
      aria-label="Add Brand"
      data-role="add-brand"
      mat-fab
      [disabled]="isAdminGroupUser === false"
      data-tracking-id="btn-add-brand"
    >
      <span class="mat-mdc-button-wrapper" data-id="icon-wrapper">
        <i class="material-icons" style="font-size: 30px" data-placeholder="plus-icon">add</i>
      </span>
    </button>

    <!-- Download Button -->
    <button
      style="right: 50px; top: 8px; position: absolute; height: 35px; width: 35px;"
      *ngIf="brands?.length > 0"
      (click)="onDownloadAllClick()"
      aria-label="Download"
      matTooltip="Download Records"
      color="accent"
      mat-fab
      data-role="download-records"
      data-extra="dl-btn"
    >
      <span class="mat-mdc-button-wrapper" data-icon-area="download">
        <i class="material-icons" style="font-size: 30px" data-placeholder="download-icon">download</i>
      </span>
    </button>

    <mat-card-subtitle data-marker="subtitle"></mat-card-subtitle>

    <div class="row" data-area="filters" aria-live="polite">
      <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9" data-container="filter-left"></div>
      <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3" data-container="filter-right">
        <app-filter-input
          *ngIf="brands && brands.length > 0"
          (filterChanged)="applyBrandFilter($event)"
          data-component="filter-input"
        ></app-filter-input>
      </div>
    </div>

    <mat-card-content data-body="content-area">
      <div class="table-responsive" data-wrapper="table-area" aria-live="assertive">
        <!-- Table -->
        <table
          *ngIf="brands?.length > 0"
          mat-table
          matSort
          [dataSource]="dataSource"
          (matSortChange)="announceBrandSort($event)"
          class="mat-elevation-z8"
          aria-label="Table listing brands"
          data-table-id="brand-table"
        >
          <!-- Serial Number Column -->
          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef data-header="serial-no">S No.</th>
            <td mat-cell *matCellDef="let element; let i = index" data-cell="serial-no">
              {{
                i + 1 + (pageEvent?.pageSize ?? paginator.pageSize) *
                (pageEvent?.pageIndex ?? paginator.pageIndex)
              }}
            </td>
          </ng-container>

          <!-- Hidden brandId Column -->
          <ng-container matColumnDef="brandId">
            <th mat-header-cell *matHeaderCellDef hidden data-col="id-col"></th>
            <td mat-cell *matCellDef="let element" hidden data-col="id-val">{{ element.brandId }}</td>
          </ng-container>

          <!-- Brand Name -->
          <ng-container matColumnDef="brandName">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              aria-label="Brand Name"
              sortActionDescription="Sort by brandName"
              data-header="brand-name"
            >
              Brand Name
            </th>
            <td mat-cell *matCellDef="let element" data-cell="brand-name">
              {{ element.brandName }}
            </td>
          </ng-container>

          <!-- Description -->
          <ng-container matColumnDef="description">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              aria-label="Description"
              sortActionDescription="Sort by description"
              data-header="description"
            >
              Description
            </th>
            <td mat-cell *matCellDef="let element" data-cell="description">
              {{ element.description }}
            </td>
          </ng-container>

          <!-- Active -->
          <ng-container matColumnDef="isActive">
            <th mat-header-cell *matHeaderCellDef data-header="active">Active</th>
            <td mat-cell *matCellDef="let element" data-cell="active">
              {{ element.isActive }}
            </td>
          </ng-container>

          <!-- Deleted -->
          <ng-container matColumnDef="isDeleted">
            <th mat-header-cell *matHeaderCellDef data-header="deleted">Deleted</th>
            <td mat-cell *matCellDef="let element" data-cell="deleted">
              {{ element.isDeleted }}
            </td>
          </ng-container>

          <!-- Edit -->
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef data-header="edit">Edit</th>
            <td mat-cell *matCellDef="let element" data-cell="edit">
              <button
                mat-mini-fab
                aria-label="Edit"
                tabindex="0"
                [disabled]="!isAdminGroupUser"
                (click)="onEditBrand($event, element)"
                data-btn="edit-brand"
                data-extra="edit-action"
              >
                <mat-icon>create</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Delete -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef data-header="delete">Delete</th>
            <td mat-cell *matCellDef="let element" data-cell="delete">
              <button
                mat-mini-fab
                color="warn"
                aria-label="Delete"
                [disabled]="isAdminGroupUser === false"
                (click)="onDeleteBrand($event, element)"
                data-btn="delete-brand"
                data-extra="delete-action"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Row Definitions -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns" data-row="header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" data-row="data-row"></tr>
        </table>

        <!-- Paginator -->
        <mat-paginator
          [length]="totalRows"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = $event; pageChanged($event)"
          aria-label="Pagination"
          data-element="paginator"
          data-meta="pagination-control"
        ></mat-paginator>

        <!-- Loader -->
        <div *ngIf="isLoaderResult" class="custSpinner" aria-busy="true" data-loader="true"></div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
